import script from "./doc-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./doc-editor.vue?vue&type=script&setup=true&lang=js"

import "./doc-editor.vue?vue&type=style&index=0&id=5f1ae3d0&lang=scss"

export default script